import { render, staticRenderFns } from "./CustomFieldsLibrary.vue?vue&type=template&id=f28d06ae&scoped=true"
import script from "./CustomFieldsLibrary.vue?vue&type=script&lang=js"
export * from "./CustomFieldsLibrary.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldsLibrary.vue?vue&type=style&index=0&id=f28d06ae&prod&scoped=true&lang=css"
import style1 from "./CustomFieldsLibrary.vue?vue&type=style&index=1&id=f28d06ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d06ae",
  null
  
)

export default component.exports